import React from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";

const MapComponent = withScriptjs(
  withGoogleMap(({ lat, lng }) => {
    return (
      <GoogleMap
        zIndex={1}
        defaultZoom={16}
        defaultCenter={{ lat: lat, lng: lng }}
      >
        <Marker position={{ lat: lat, lng: lng }} />
      </GoogleMap>
    );
  })
);

export default MapComponent;



// WEBPACK FOOTER //
// ./src/components/Map/Map.js